import React, { useRef } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Parallax, ParallaxLayer } from "react-spring/renderprops-addons"
import { useMediaQuery } from "react-responsive"

import Layout from "../components/layout"
import SEO from "../components/seo"

import style from "./index.module.scss"
import WatIsWeef from "../components/watisweef"
import Geschiedenis from "../components/geschiedenis"
import Kapelhuis from "../components/kapelhuis"
import Citaat from "../components/citaat"
import Kunstenaars from "../components/kunstenaars"
import Contact from "../components/contact"
import Landing from "../components/landing"

import LayoutMobile from "../components/layoutMobile"
import LandingMobile from "../components/landingMobile"
import CitaatMobile from "../components/citaatMobile"
import WatIsWeefMobile from "../components/watIsWeefMobile"
import GeschiedenisMobile from "../components/geschiedenisMobile"
import KapelhuisMobile from "../components/kapelhuisMobile"
import KunstenaarsMobile from "../components/kunstenaarsMobile"
import ContactMobile from "../components/contactMobile"
import CitaatBarsMobile from "../components/citaatBarsMobile"

export default function IndexPage() {
  const data = useStaticQuery(
    graphql`
      query MyQuotes {
        allTekstJson {
          edges {
            node {
              citaten {
                intro
                geschiedenis {
                  info
                  quote
                }
                kapelhuis {
                  info
                  quote
                }
                kunstenaars {
                  info
                  quote
                }
                wat {
                  info
                  quote
                }
              }
            }
          }
        }
      }
    `
  )
  const quotes = data.allTekstJson.edges[0].node.citaten
  const citaatSpeed = 0.5
  const barStyle = {
    width: "100vw",
    height: "1100vh",
    display: "grid",
    gridTemplateRows: "100%",
    gridTemplateColumns: "repeat(22,1fr)",
    maxWidth: "100vw",
    // border: "10px solid black",
  }
  const parallaxRef = useRef()
  const weefselRef = useRef()

  const isDesktop = useMediaQuery({ query: "(min-device-width: 1225px)" })
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" })

  return (
    <>
      {isTabletOrMobile && (
        <LayoutMobile>
          <Parallax pages={21}>
            <ParallaxLayer offset={0}>
              <LandingMobile></LandingMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={0.68} speed={-0.2}>
              <svg
                id="Laag_1"
                data-name="Laag 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1920 1080"
                className={style.weefselWrapper}
              >
                <path
                  className={style.offsetWeefselMobile}
                  d="M0,605.92a1459.33,1459.33,0,0,0,160.66,74.17c97.73,38.13,217.32,83.58,373.69,85.58,82.1,1,151.06,1.92,228.2-34.23,48.3-22.64,60.76-41.49,128.37-71.32a685.33,685.33,0,0,1,162.6-48.49c99.45-16.67,178.35-7.24,208.23-2.85,81.78,12,140.28,36.58,202.54,62.75,92.74,39,82,48.2,165.44,79.87,86.47,32.84,163.65,47.88,196.83,54.2,37.49,7.15,69.52,11.51,93.44,14.26"
                />
              </svg>
            </ParallaxLayer>

            <ParallaxLayer offset={1.1} speed={0}>
              <CitaatBarsMobile></CitaatBarsMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={1.1} speed={0.25}>
              <CitaatMobile
                tekst={quotes.wat.quote}
                auteur={quotes.wat.info}
              ></CitaatMobile>
            </ParallaxLayer>

            <ParallaxLayer offset={2.1}>
              <WatIsWeefMobile></WatIsWeefMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={5} speed={0}>
              <CitaatBarsMobile></CitaatBarsMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={5} speed={0.25}>
              <CitaatMobile
                tekst={quotes.geschiedenis.quote}
                auteur={quotes.geschiedenis.info}
              ></CitaatMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={6}>
              <GeschiedenisMobile></GeschiedenisMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={8.4} speed={0}>
              <CitaatBarsMobile></CitaatBarsMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={8.5} speed={0.25}>
              <CitaatMobile
                tekst={quotes.kapelhuis.quote}
                auteur={quotes.kapelhuis.info}
              ></CitaatMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={9.2}>
              <KapelhuisMobile></KapelhuisMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={12.3} speed={0.1}>
              <CitaatBarsMobile></CitaatBarsMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={12.3} speed={0.25}>
              <CitaatMobile
                tekst={quotes.kunstenaars.quote}
                auteur={quotes.kunstenaars.info}
              ></CitaatMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={13}>
              <KunstenaarsMobile></KunstenaarsMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={15.3}>
              <ContactMobile></ContactMobile>
            </ParallaxLayer>
            <ParallaxLayer offset={20} speed={-0.1}>
              <div className={style.bgContactMobile}></div>
            </ParallaxLayer>
            {/* <ParallaxLayer offset = {16.5}>
            <div style = {mobileDiv} ></div>
          </ParallaxLayer> */}
          </Parallax>
        </LayoutMobile>
      )}
      {isDesktop && (
        <Layout>
          <SEO title="erfgoed en kunst" />
          <Parallax ref={parallaxRef} pages={11.75} horizontal={false}>
            {/*---------------------------------------------------------------------------------- bars*/}

            <ParallaxLayer offset={0} style={barStyle}>
              <div className="bar3"></div>
              <div className="bar1"></div>
              <div className="bar4"></div>
              <div className="bar2"></div>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- landing*/}

            <ParallaxLayer offset={0}>
              <Landing tekst={quotes.intro}></Landing>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- quote1*/}

            <ParallaxLayer offset={1} speed={citaatSpeed}>
              <Citaat
                tekst={quotes.wat.quote}
                auteur={quotes.wat.info}
              ></Citaat>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- WAT IS WEEF */}

            <ParallaxLayer offset={2.25} speed={1} factor={1}>
              <div className={style.bgWatIsWeef}></div>
            </ParallaxLayer>

            <ParallaxLayer offset={2}>
              <WatIsWeef tekstCol={2} fotoCol={4}></WatIsWeef>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- CITAAT_2 */}

            <ParallaxLayer offset={3} speed={citaatSpeed}>
              <Citaat
                tekst={quotes.geschiedenis.quote}
                auteur={quotes.geschiedenis.info}
              ></Citaat>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- GESCHIEDENIS */}

            <ParallaxLayer offset={4.2} speed={1}>
              <div className={style.bgGeschiedenis}></div>
            </ParallaxLayer>

            <ParallaxLayer offset={4.05} speed={0.3}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
                <g id="Laag_3" data-name="Laag 3">
                  <path
                    ref={weefselRef}
                    className="offsetWeefsel reverse"
                    d="M0,733.47a1181,1181,0,0,0,134.48-6.3c83.33-8.66,173.92-18.08,274.1-66.16,68.66-33,118-72.63,144.93-94.52,57.83-47,64.82-66,129.17-116.57C722,419,760.57,388.69,815,364.85c21.83-9.56,61.5-24.77,173.28-37.8,85-9.92,106.19-6.27,277.25-12.61,138.59-5.13,157.65-8.75,207.94,0,75.64,13.16,135.48,39.25,160.68,50.41,88.92,39.39,105,67.07,176.44,91.37,59.83,20.36,113.16,22.91,148.07,22.06"
                  />
                </g>
              </svg>
            </ParallaxLayer>

            <ParallaxLayer offset={4}>
              <Geschiedenis tekstCol={3} fotoCol={1}></Geschiedenis>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- CITAAT_3 */}

            <ParallaxLayer offset={5} speed={citaatSpeed}>
              <Citaat
                tekst={quotes.kapelhuis.quote}
                auteur={quotes.kapelhuis.info}
              ></Citaat>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- KAPELHUIS */}

            <ParallaxLayer offset={6}>
              <Kapelhuis tekstCol={3} fotoCol={1}></Kapelhuis>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- CITAAT_4 */}

            <ParallaxLayer offset={7} speed={citaatSpeed}>
              <Citaat
                tekst={quotes.kunstenaars.quote}
                auteur={quotes.kunstenaars.info}
              ></Citaat>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- KUNSTENAARS */}

            <ParallaxLayer offset={8} speed={0.3}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
                <g id="Laag_3" data-name="Laag 3">
                  <path
                    className="offsetWeefsel"
                    d="M0,100.2a513.13,513.13,0,0,1,134.48,34.66c111.28,45.74,137.34,110.3,252.05,148.08A762.51,762.51,0,0,0,522,314.44c81.62,11,112.52,1.11,293-6.3,123.5-5.06,152.38-2.22,185.88,6.3,73.29,18.66,123.88,53.15,141.78,66.17,76.39,55.56,76.24,97.51,148.08,182.73,91.43,108.48,193.56,161.39,217.39,173.28,92.27,46.07,176.55,59.38,239.44,69.32a1029.53,1029.53,0,0,0,161.71,12.6"
                  />
                </g>
              </svg>
            </ParallaxLayer>

            <ParallaxLayer offset={8} factor={2}>
              <Kunstenaars tekstCol={2} fotoCol={4}></Kunstenaars>
            </ParallaxLayer>

            {/*---------------------------------------------------------------------------------- PROGRAMMA */}

            {/* <ParallaxLayer offset={10}>
            <Programma></Programma>
          </ParallaxLayer> */}

            {/*---------------------------------------------------------------------------------- ARCHIEF */}

            {/* <ParallaxLayer
            id="archief"
            offset={11}
            factor= {3.5}
            onMouseOver={() => {
              setLock(true)
            }}
            onMouseOut={() => {
              setLock(false)
            }}
          >
            
          </ParallaxLayer> */}

            {/*---------------------------------------------------------------------------------- CONTACT */}

            <ParallaxLayer offset={10.75} speed={-0.1}>
              <div className={style.bgContact}></div>
            </ParallaxLayer>

            <ParallaxLayer offset={10.75}>
              <Contact teamCol={1} contactCol={3}></Contact>
            </ParallaxLayer>
          </Parallax>
        </Layout>
      )}
    </>
  )
}
